import { Component, OnInit, Input, ViewEncapsulation, EventEmitter, Output } from '@angular/core';
import { IQuestionGroupQuestion } from "../../shared/models/interfaces/question-group-question";
import { Question } from '../../shared/models/question.model';

@Component({
  selector: 'app-question-group-question',
  templateUrl: './question-group-question.component.html',
  styleUrls: ['./question-group-question.component.scss'],

})
export class QuestionGroupQuestionComponent implements OnInit {

  @Input() questionGroupQuestion: IQuestionGroupQuestion;
  @Input() questionGroupIndex: number;
  @Input() questionIndex: string;
  @Input() isReadOnly: boolean;
  @Output() questionAnsweredEvent: EventEmitter<any> = new EventEmitter<any>();
  questionFormatted: string;

  constructor() { }

  ngOnInit() {
  }

  helpTextExist(question: Question) {
    if (question.helpText && question.helpText !== '') {
      return true;
    } else {
      return false;
    }
  }

  questionGroupAndQuestionIndex() {
    if (this.questionGroupIndex == null || this.questionIndex == null) {
      return `—`;
    }
    return this.questionGroupIndex + "." + this.questionIndex;
  }

  getFormattedQuestion(question: Question) {
    const questionText = question.description;
    this.questionFormatted = questionText.replace(/(?:\r\n|\r|\n)/g, '<br />');
    return this.questionFormatted;
  }

  questionAnswered() {
    this.questionAnsweredEvent.next(null);
  }
}
